import { BREAKPOINTS } from '@/constants/app.constants';
import * as React from 'react';

type DeviceType = {
  isMobile: boolean;
  isTablet: boolean;
};

export function useResponsive() {
  const [deviceType, setDeviceType] = React.useState<DeviceType>({
    isMobile: false,
    isTablet: false,
  });

  React.useEffect(() => {
    const updateDeviceType = () => {
      const width = window.innerWidth;
      setDeviceType({
        isMobile: width < BREAKPOINTS.MD,
        isTablet: width >= BREAKPOINTS.MD && width < BREAKPOINTS.LG,
      });
    };

    // Initial check
    updateDeviceType();

    // Create media query listeners
    const mobileQuery = window.matchMedia(
      `(max-width: ${BREAKPOINTS.MD - 1}px)`
    );
    const tabletQuery = window.matchMedia(
      `(min-width: ${BREAKPOINTS.MD}px) and (max-width: ${BREAKPOINTS.LG - 1}px)`
    );

    // Event listeners
    const handlers = new Map([
      [mobileQuery, updateDeviceType],
      [tabletQuery, updateDeviceType],
    ]);

    // Add listeners
    handlers.forEach((handler, query) => {
      query.addEventListener('change', handler);
    });

    // Cleanup
    return () => {
      handlers.forEach((handler, query) => {
        query.removeEventListener('change', handler);
      });
    };
  }, []);

  return {
    ...deviceType,
    isDesktop: !deviceType.isMobile && !deviceType.isTablet,
    isMobileOrTablet: deviceType.isMobile || deviceType.isTablet,
  };
}
